import {createSlice} from "@reduxjs/toolkit";

let l = localStorage.getItem('ProductListingSettings')
if (l) {
    l = JSON.parse(l);
} else {
    l = {
        compact_view: false,
        filter_box_expanded: false,
    }
}

const setAllToLocalStorage = (data) => {
    data = JSON.parse(JSON.stringify(data))
    localStorage.setItem('ProductListingSettings', JSON.stringify(data))
}
const slice = createSlice({
        name: "ProductListingSettings",
        initialState: l,
        reducers: {
            setSettings: {
                reducer: (state, action) => {
                    state[action.payload.key] = action.payload.value;
                    setAllToLocalStorage(state)
                },
            }
        }
    })
;

export let {setSettings} = slice.actions;

export default slice.reducer;
